<template>
  <div class="installation-list">
    <div class="installation-list__header">
      <div>
        <s-search-input
          class="installation-list__search-input-group"
          v-model="searchTerm"
          v-s-trigger="changingSearch"
          :placeholder="$t('installation-manager.query.search-placeholder')"
        />
      </div>
    </div>
    <s-table
      class="installation-list__table"
      :fields="fields"
      :items="items"
      :busy="loading"
    >
      <template
        v-for="field in fields"
        #[`cell(${field.key})`]="data"
      >
        {{ data.value || '-' }}
      </template>
      <template #cell(actions)="data">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="editInstallation(data.item)"
        >
          <span class="fa fa-edit" />
          {{ $t('installation-manager.query.list.edit') }}
        </b-button>
      </template>
    </s-table>
    <grid-paginator
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="perPage"
      @input="paging()"
    />
  </div>
</template>

<script>
import GridPaginator from '@/components/lists/Paginator';
import { delayed } from '@/services/observables';
import Service from '@/domain/services/installation';
import installationTableFields from '@/domain/data/generalPanel/adminPanel/installation/installationTableFields';

export default {
  components: {
    GridPaginator,
  },
  data: vm => ({
    searchTerm: null,
    loading: true,
    doDelayedRequest: delayed(() => vm.doRequest()),
    currentPage: 1,
    totalItems: null,
    perPage: 10,
    items: [],
  }),
  computed: {
    effectiveSearchTerm() {
      return this.searchTerm && this.searchTerm.length >= 3 ? this.searchTerm : null;
    },
    fields() {
      return installationTableFields(this);
    },
  },
  created() {
    this.refreshItems();
  },
  methods: {
    paging() {
      this.refreshItems();
    },
    changingSearch() {
      this.currentPage = 1;
      this.refreshItems();
    },
    editInstallation(installation) {
      this.$router.push({
        name: 'installation.edit',
        params: {
          installationId: installation.installationId,
        },
      });
    },
    async refreshItems() {
      this.items = [];
      this.loading = true;
      try {
        return await this.doDelayedRequest();
      } finally {
        this.loading = false;
      }
    },
    doRequest() {
      return Service.getInstallationList(this.getRequestFilter())
        .then(this.getProjectRequestResult());
    },
    getRequestFilter() {
      return {
        filter: {
          genericSearch: this.effectiveSearchTerm,
        },
        page: this.currentPage,
        pageSize: this.perPage,
      };
    },
    getProjectRequestResult() {
      return (paged) => {
        this.totalItems = paged.total;
        this.items = paged.data;
      };
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.installation-list
  &__header
    display: flex
    flex-direction: column
    padding: 10px
    button
      margin-top: 1em
  &__options-btn
    margin: -10px 0
    &__option-icon
      margin-right: 5px
  ::v-deep &__cell
    &-installation
      width: 15%
    &-federative-unit
      width: 5%
    &-complex
      width: 20%
    &-installation-type
      width: 15%
    &-regional
      width: 15%
    &-company
      width: 23%
    &-actions
      width: 7%
      min-width: 10em
  ::v-deep
    th.installation-list__cell-actions
      pointer-events: none
  +media-min-sm()
    &__search-input-group
      width: 350px
      margin-bottom: 5px
    &__header
      flex-direction: row
      justify-content: space-between
      button
        margin-top: 0
        margin-left: 1em
</style>
